export enum CategoryType {
  EXPENSE = 'EXPENSE',
  INCOME = 'INCOME',
}
